import { ModalModel } from "../models/modalModel";
import { EDIT_MODAL, ModalActionTypes, SET_MODAL } from "../types/actions";


const modalReducerDefaultState: ModalModel = {
    id: '', name: '', show: false, properties: {
        title: '',
        modalLarge: false,
        modelCentered: false,
    },
    cssStyles: [{
        id: '', value: '', retrivedStyle: '', style:'',
    }]
};

const modalReducer = (state: ModalModel = modalReducerDefaultState, action: ModalActionTypes): ModalModel => {
    switch (action.type) {
        case SET_MODAL:
            return action.modal;
        case EDIT_MODAL:
            return { ...state, ...action.modal }
        default:
            return state;
    }
}

export default modalReducer
